export default "__VITE_ASSET__CxiEPCKN__"